module.exports = __webpack_public_path__ + "img/09.ec6f1f47.jpg";